<span>
  <span class="ui-icon ui-icon-triangle-1-e" [ngClass]="{'ui-icon-triangle-1-e': !isActive, 'ui-icon-triangle-1-s': isActive}"></span>
</span>
<ng-content></ng-content>
